// ./src/contexts/CategoriesContext/CategoriesContext.tsx
//
// Thin context wrapper around the useCategories hook. All derived data lives in
// the hook itself. See HighlightsContext for the pattern.

import React, { createContext, useContext } from "react";

import { useCategories, UseCategoriesOptions, UseCategoriesReturn } from "@/hooks/useCategories";

const CategoriesContext = createContext<UseCategoriesReturn | null>(null);

export interface CategoriesProviderProps extends UseCategoriesOptions {
  children: React.ReactNode;
}

export const CategoriesProvider: React.FC<CategoriesProviderProps> = ({ children, ...options }) => {
  const value = useCategories(options);

  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
};

export const useCategoriesContext = (): UseCategoriesReturn => {
  const context = useContext(CategoriesContext);

  if (!context) {
    throw new Error(
      "useCategoriesContext must be used within a <CategoriesProvider>. " +
        "Wrap your component tree with <CategoriesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalCategoriesContext = (): UseCategoriesReturn | null => {
  return useContext(CategoriesContext);
};
